import { supabase } from "./supabase";
import { copiaDaTabela } from "../constants";

// Tabelas comerciais do combustível (migração 20261029000000). Quem pode ler e
// gravar é decidido no banco (RLS: só a equipe); aqui é só o transporte.

const numeroBR = (v) => {
  const n = parseFloat(String(v ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : null;
};

export async function listarTabelas({ soAtivas = false } = {}) {
  let q = supabase.from("tabelas_comerciais").select("*").order("nome", { ascending: true });
  if (soAtivas) q = q.eq("ativa", true);
  const { data, error } = await q;
  if (error) throw new Error(error.message);
  return data || [];
}

/** Grava a tabela do jeito que o banco espera (números em ponto, dias inteiros). */
export async function salvarTabela(t) {
  const linha = {
    codigo: String(t.codigo || "").trim().toUpperCase(),
    nome: String(t.nome || "").trim(),
    descricao: String(t.descricao || "").trim() || null,
    prazos: (t.prazos || []).map((p) => ({ dias: Number(p.dias), taxa: numeroBR(p.taxa) })),
    aluguel_mensal: numeroBR(t.aluguel_mensal) ?? 0,
    isencao_acima: String(t.isencao_acima ?? "").trim() ? numeroBR(t.isencao_acima) : null,
    formas_pagamento: t.formas_pagamento || [],
    ativa: t.ativa !== false,
  };
  const req = t.id
    ? supabase.from("tabelas_comerciais").update(linha).eq("id", t.id).select("*").single()
    : supabase.from("tabelas_comerciais").insert(linha).select("*").single();
  const { data, error } = await req;
  if (error) {
    if (/duplicate key|unique/i.test(error.message)) throw new Error(`Já existe uma tabela com o código ${linha.codigo}.`);
    throw new Error(error.message);
  }
  return data;
}

/**
 * O convite que o link leva: guarda no banco a cópia da tabela escolhida e
 * devolve só o id. O posto não consegue trocar a tabela editando o link — o
 * banco aplica a do convite e ignora o resto.
 */
export async function criarConvite(linhaTabela, partnerId = null) {
  const tabela = copiaDaTabela(linhaTabela);
  const { data, error } = await supabase
    .from("convites_ficha")
    .insert({ tabela_comercial: tabela, partner_id: partnerId || null })
    .select("id")
    .single();
  if (error) throw new Error(error.message);
  return data.id;
}

/** O formulário público lê a tabela do convite (função do banco liberada ao anônimo). */
export async function tabelaDoConvite(conviteId) {
  if (!conviteId) return null;
  const { data, error } = await supabase.rpc("tabela_do_convite", { p_convite: conviteId });
  if (error) return null;
  return data && Array.isArray(data.prazos) && data.prazos.length ? data : null;
}

// ── Estados com taxa definida no cadastro (regioes_comerciais) ──────────────
// A lista vem do banco pela função liberada ao anônimo (o formulário público
// precisa dela). Guardada por sessão: muda raramente, e o banco confere de novo.
let ufsCache = null;
export async function ufsCondicaoExclusiva({ recarregar = false } = {}) {
  if (ufsCache && !recarregar) return ufsCache;
  const { data, error } = await supabase.rpc("ufs_condicao_exclusiva");
  if (error) return ufsCache || [];
  ufsCache = Array.isArray(data) ? data : [];
  return ufsCache;
}

export async function listarRegioes() {
  const { data, error } = await supabase.from("regioes_comerciais").select("*").order("uf");
  if (error) throw new Error(error.message);
  return data || [];
}

export async function marcarRegiao(uf, exige) {
  const req = exige
    ? supabase.from("regioes_comerciais").upsert({ uf, exige_condicao_exclusiva: true }, { onConflict: "uf" })
    : supabase.from("regioes_comerciais").delete().eq("uf", uf);
  const { error } = await req;
  if (error) throw new Error(error.message);
  ufsCache = null;
}
